/* import __COLOCATED_TEMPLATE__ from './tab-header-area.hbs'; */
import Component from '@ember/component';
import { computed, action } from '@ember/object';
import { service } from '@ember/service';
import utilities from '../utils/utilities';

const TAB_NAME_LIST = ['Graph', 'Circuit', 'Parts'];

////////////////////////////////////////////////////////////////////////////////////
// tab-header-area - This is the Component for the Header Tabs and Links          //
////////////////////////////////////////////////////////////////////////////////////

export default class TabHeaderArea extends Component {
  tagName = '';
  @service('aditools-analytics') analytics;
  @service site;

  ////////////////////////////////////////////////////////////////////////////////
  // Computed Values                                                            //
  ////////////////////////////////////////////////////////////////////////////////

  @computed('selectedTab') get activeTab() {
    return TAB_NAME_LIST[this.selectedTab - 1];
  }

  ////////////////////////////////////////////////////////////////////////////////
  // User Functions                                                             //
  ////////////////////////////////////////////////////////////////////////////////

  adjustTitleDimensions() {
    if (window.innerWidth < 640) {
      let iconsWidth = document.querySelector('#icon-div').clientWidth;
      let titleWidth = window.innerWidth - iconsWidth;
      let titleElement = document.querySelector('.tight-title');
      titleElement.style.width = titleWidth + 'px';
      titleElement.style.minWidth = titleWidth + 'px';
    }
  }

  ////////////////////////////////////////////////////////////////////////////////
  // Component Actions                                                          //
  ////////////////////////////////////////////////////////////////////////////////

  @action insertingTabHeader() {
    var self = this;
    self.set('viewSize', utilities.findBootstrapEnvironment());
    self.set('viewSizePx', window.innerWidth);

    var rtime,
      timeout = false,
      delta = 200;

    window.addEventListener('resize', function () {
      rtime = new Date();
      if (timeout === false) {
        timeout = true;
        setTimeout(resizeEnd, delta);
      }
    });

    function resizeEnd() {
      if (new Date() - rtime < delta) {
        setTimeout(resizeEnd, delta);
      } else {
        timeout = false;
        if (!self.isDestroying && !self.isDestroyed) {
          self.set('viewSize', utilities.findBootstrapEnvironment());
          self.set('viewSizePx', window.innerWidth);
        }
      }
    }
  }

  @action destroyingTabHeader() {}

  @action setTitleWidth() {
    let titleWidth = 200;
    if (window.innerWidth < 640) {
      let iconsWidth = document.querySelector('#icon-div').clientWidth;
      titleWidth = window.innerWidth - iconsWidth - 14; // padding on left (8px) and right (6px)
    }
    return titleWidth;
  }

  @action feedbackClick() {
    this.analytics.setWebEvent(this.toolName, 'feedbackViewed', '');
  }

  @action postDialogAnalytics(dialogEvent) {
    this.analytics.setWebEvent(this.toolName, dialogEvent, '');
  }

  @action closeShare() {}

  @action insertedSharePopup() {
    const dialog = document.querySelector('#share-dialog');
    dialog.showModal();
  }
  @action closeShareDialog(doClose, evt) {
    const dialog = document.querySelector('#share-dialog');
    const popup = document.querySelector('#share-popup');
    const target = evt.target;
    if (!popup.contains(target)) {
      dialog.close();
      doClose();
    }
  }
}
